#version 300 es
precision highp float;

in vec2 a_pos;
uniform mat4 u_matrix;
uniform vec4 u_bbox;

out vec2 v_tex_pos;

void main(){
    v_tex_pos=a_pos;
    gl_Position=vec4(1.-2.*a_pos,0,1);
    //gl_Position = u_matrix * vec4(1.0 - 2.0 * a_pos, 0, 1);
    //float x = u_bbox[0] + a_pos[0] * (u_bbox[2] - u_bbox[0]);
    //float y = u_bbox[1] + a_pos[1] * (u_bbox[3] - u_bbox[1]);
    //gl_Position = vec4(1.0 - 2.0 * vec2(x, y), 0, 1);
}
